import { observable, makeObservable } from 'mobx';
import { ModalParams } from 'core/models';

class ErrorModalParams extends ModalParams {
	@observable message = null;
	@observable label = 'Close';

	constructor(opts) {
        super(opts);
        makeObservable(this);
        this.onClose = (opts && opts.onClose) || this.close;
    }
	open({ message }) {
		this.message = message;
		super.open();
	}
}

export default ErrorModalParams;



// WEBPACK FOOTER //
// ./src/core/models/ErrorModalParams.js